// src/hooks/useCompanies.js
import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function useCompanies() {
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading]     = useState(false);
    const [error, setError]         = useState("");

    const fetchCompanies = useCallback(async () => {
        setLoading(true); setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/companies`, { withCredentials: true, timeout: 30000 });
            setCompanies(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setError(e?.response?.data?.error || e?.message || "Konnte Firmen nicht laden.");
        } finally {
            setLoading(false);
        }
    }, []);

    const createCompany = useCallback(async ({ name, street=null, zip=null, city=null }) => {
        if (!name?.trim()) throw new Error("Firmenname ist Pflichtfeld.");
        const res = await axios.post(`${API_BASE}/api/companies`, { name: name.trim(), street, zip, city }, {
            withCredentials: true, timeout: 30000,
        });
        if (res.status >= 400) throw new Error(res?.data?.error || "Erstellen fehlgeschlagen.");
        await fetchCompanies();
        return res?.data?.company || null;
    }, [fetchCompanies]);

    useEffect(() => { fetchCompanies(); }, [fetchCompanies]);

    return { companies, loading, error, fetchCompanies, createCompany };
}
